//Callback of reactRouterDom className or style props
export const useIsActive = ({ isActive }: { isActive: boolean }) => {
  return isActive ? "active" : "";
};
